"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("@material-ui/core/colors");
/**
 * Styles
 */
var styles = function (_theme) { return ({
    cartContainer: {
        maxWidth: 1024
    },
    cartGridItem: {
        borderBottom: "1px solid " + colors_1.grey[400],
        padding: '14px 0px'
    },
    cartGridColumn: {
        padding: '0 10px'
    },
    summaryRow: {
        justifyContent: 'space-between',
        marginBottom: 8
    },
    checkoutButton: {
        marginTop: 28,
        width: '100%'
    },
    itemBookTitle: {
        fontWeight: 700,
        fontSize: 16
    },
    lineItemDetails: {
        width: 'calc(100% - 152px)',
        paddingLeft: 14,
        justifyContent: 'space-between'
    },
    lineItemDetailTitleLine: {
        justifyContent: 'space-between'
    },
    removeButton: {
        width: 'auto'
    },
    couponCodeCollumn: {
        width: '48%'
    },
    couponCodeForm: {
        padding: '10px 0',
        width: '100%'
    },
    couponCodeInput: {
        width: '100%'
    },
    couponCodeButton: {
        width: '100%',
        height: '100%'
    }
}); };
exports.default = styles;
